"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.rag.name': 'Baza Wiedzy',
    'tools.rag.description': 'Wyszukiwanie i pobieranie odpowiednich informacji z dokumentów bazy wiedzy',
};
